module.exports = __webpack_public_path__ + "static/img/Order_Finish@3x.7f8b3dca.png";